import loadable from '@loadable/component';
import React from 'react';

export const returnComponent = (component) => {
    const OtherComponent = loadable(() => import(`app/modules/journey/ui/containers/steps/${component}`))
    return <OtherComponent />
}

